module.exports = __webpack_public_path__ + "static/media/icon-text-section.4907ce90.png";